// REACT
import React from "react";

// MATERIAL-UI
import { List, ListItem, ListItemText, ListItemAvatar, Typography } from "@mui/material";

// COMPONENTS
import CountryOrCryptoFlag from "src/components/common/CountryOrCryptoFlag";
import Rank from "src/components/markets/Rank";

// ASSESTS
import { FilterStyles } from "../styles/Filter.styles";
import formatCoinName from "src/utils/formatCoinName";
import { SearchListProps } from "./types";
import { useHistory } from "react-router-dom";
import { trackEvent } from "src/Amplitude";

const SearchListMarket = (props: SearchListProps) => {
  const classes = FilterStyles();
  const history = useHistory();
  const handleCoinPage = (code: string) => {
    history.push(`/coin/${code.toLowerCase()}`);
  };

  if (props.data.length === 0) {
    return <Typography>Could not be found.</Typography>;
  }

  return (
    <List className={classes.listContainer}>
      {props.data.map((el, i) => (
        <ListItem
          id={`list-item-${el.code}-${i}`}
          key={`${el.code}-${i}`}
          className={classes.listItem}
          onClick={() => {
            handleCoinPage(el.code);
            trackEvent(`Select_Search_Bar`, { token: el.code }, "Global_Search_Bar");
          }}>
          {/* RANK */}
          <ListItemText className={classes.listItemRank}>
            <Rank rank={el.rank} isActive={true} />
          </ListItemText>
          {/* ICON */}
          <ListItemAvatar className={classes.listItemIcon}>
            <CountryOrCryptoFlag name={el?.logoUrl || el.code} size={30} />
          </ListItemAvatar>
          {/* NAME AND CODE */}
          <ListItemText className={classes.listName}>
            <b>{formatCoinName(el.name)}</b> {el.code}
          </ListItemText>
        </ListItem>
      ))}
    </List>
  );
};

export default SearchListMarket;
